<section class="heading flex">
  @if (brandingData) {
    <div class="logo-small">
      <img [src]="brandingData.logo.sm.href" alt="" />
    </div>
    <div class="logo-large logo-55">
      <img [src]="brandingData.logo.lg.href" alt="" />
    </div>
    <div class="logo-mobile">
      <img [src]="brandingData.logo.lg.href" alt="" />
    </div>
  }
</section>

@let counters = (badgesModel.state.counters$ | async) || {};
<section
  class="navigation scroll-wrapper scrollbar-gray invisible-collapsed"
  [appScrollDetector]="'with-scroll'"
>
  @for (element of menuElements; track element; let i = $index) {
    <ng-container *appExperimentalFeature="element.isExperimentalFeature">
      @let childrenLength = element.children?.length ?? 0;

      <div
        class="navigation-item {{ element.cssClass }}"
        [class.hidden]="element.hidden"
        [class.expanded]="element.isExpanded"
        [class.has-children]="element.children?.length"
        *appCheckPricingPlan="element.requirePricingPlan ?? []"
        [class.disabled]="!!element.disabled"
        [appMenuTooltip]="collapsed && childrenLength > 0 ? childTmpl : undefined"
        [tooltipStyleClass]="'sidebar-overlay-menu small-offset no-arrow mw-450'"
        [autoHide]="false"
        [tooltipPosition]="'right'"
        [appendTo]="'body'"
      >
        <div
          class="content"
          [appCheckAccess]="element.checkAccess"
          [routerLink]="element.path"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="$event.stopPropagation()"
        >
          <div class="icon-wrapper">
            @if (element.icon) {
              <app-dynamic-host
                [componentInputs]="{ color: 'var(--icon-color)' }"
                [componentType]="element.icon"
              ></app-dynamic-host>
            }
          </div>

          <div
            class="text-wrapper text-16 fw-500"
            [class.with-action-button]="element.actionButton"
          >
            {{ element.name | translate }}
            @if (element.actionButton) {
              <p-button
                class="action-button flex"
                [disabled]="
                  element?.actionButton?.checkAccess
                    ? (accessControl.check$($any(element?.actionButton?.checkAccess)) | async) ===
                      false
                    : false
                "
                [appTooltip]="element.actionButton.name | translate"
                [tooltipPosition]="'top'"
                [routerLink]="element.actionButton.path"
                (click)="$event.stopPropagation()"
              >
                @if (element.actionButton.icon) {
                  <app-dynamic-host
                    [componentInputs]="{ color: 'var(--icon-color)' }"
                    [componentType]="element.actionButton.icon"
                  ></app-dynamic-host>
                }
              </p-button>
            }
          </div>

          @if (element.counterKey && counters[element.counterKey]) {
            @let counter = counters[element.counterKey];
            <p-badge [value]="counter > 99 ? '99+' : counter" [class]="'counter-badge'" />
          }

          <div
            (click)="toggleElementExpanded(element); $event.stopPropagation()"
            class="expand-icon"
          >
            <app-icon-chevron
              [color]="'var(--icon-color)'"
              [direction]="element.isExpanded ? 'up' : 'down'"
            ></app-icon-chevron>
          </div>
        </div>

        @if (element.children?.length) {
          <ng-container [ngTemplateOutlet]="childTmpl"></ng-container>
        }

        <ng-template #childTmpl>
          <div class="children">
            @for (child of element.children; track child) {
              <div class="navigation-item {{ child.cssClass }}">
                <div
                  class="content"
                  [appCheckAccess]="child.checkAccess"
                  [routerLinkActive]="'active'"
                  [routerLink]="child.path"
                  (click)="$event.stopPropagation()"
                >
                  @if (child.icon) {
                    <div class="icon-wrapper">
                      @if (child.icon) {
                        <app-dynamic-host
                          [componentInputs]="{ color: 'var(--icon-color)' }"
                          [componentType]="child.icon"
                        ></app-dynamic-host>
                      }
                    </div>
                  }
                  <div class="text-wrapper text-16 fw-500">
                    {{ child.name | translate }}
                  </div>
                  @if (
                    child.counterKey && child.counterKey in counters && counters[child.counterKey]
                  ) {
                    @let counter = counters[child.counterKey];
                    <p-badge [value]="counter > 99 ? '99+' : counter" styleClass="counter-badge" />
                  }
                </div>
              </div>
            }
          </div>
        </ng-template>
      </div>
    </ng-container>
  }

  <div class="spacer"></div>

  <div class="fixed-bottom">
    @if (!deviceService.isPWA && !IS_NATIVE_PLATFORM) {
      @let installPwaEvent = installPwaEvent$ | async;
      @if (
        deviceService.osName === 'iOS' || (deviceService.osName === 'Android' && !installPwaEvent)
      ) {
        <div class="navigation-item install" (click)="pwaInstallRef.open()">
          <div class="content">
            <div class="icon-wrapper">
              <app-icon-download color="var(--icon-color)"></app-icon-download>
            </div>

            <div class="text-wrapper text-16 fw-500">
              {{ 'fleet.menu.install-app' | translate }}
            </div>
          </div>
        </div>
      } @else if (installPwaEvent) {
        <div class="navigation-item install" (click)="promptPWAInstall()">
          <div class="content">
            <div class="icon-wrapper">
              <app-icon-download color="var(--icon-color)"></app-icon-download>
            </div>

            <div class="text-wrapper text-16 fw-500">
              {{ 'fleet.menu.install-app' | translate }}
            </div>
          </div>
        </div>
      }
    }

    <div class="navigation-item settings">
      <div
        [routerLinkActive]="'active'"
        [routerLink]="['settings']"
        class="content"
        (click)="$event.stopPropagation()"
      >
        <div class="icon-wrapper">
          <app-icon-settings [color]="'var(--icon-color)'"></app-icon-settings>
        </div>
        <div class="text-wrapper text-16 fw-500">
          {{ 'fleet.menu.settings' | translate }}
        </div>
        <div class="expand-icon"></div>
      </div>
    </div>

    <app-assistant-menu-button [isCollapsed]="collapsed"></app-assistant-menu-button>
  </div>
</section>

<div class="horizontal-spacer--24"></div>

<section class="footer">
  @if (profile.state | async; as user) {
    <div class="personal-info">
      <app-avatar
        (click)="personalMenuRef.toggle($event)"
        [photo]="user.photo"
        class="mr-12 clickable"
      ></app-avatar>
      <div class="info-wrapper">
        <div class="name text-14 fw-600">{{ user.name }}</div>
        <div class="email text-14 fw-400">
          @if (user?.email?.includes('@telematicsalerts.com')) {
            {{ user?.username }}
          } @else {
            {{ user?.email || user?.username }}
          }
        </div>
      </div>
      <app-icon-chevron
        (click)="personalMenuRef.toggle($event)"
        [color]="'var(--icon-color)'"
        [direction]="'down'"
        class="icon clickable"
      ></app-icon-chevron>
    </div>
  }
  <div class="feedback-area">
    <app-feedback-button [isCompact]="collapsed" />
  </div>
</section>

<app-personal-menu
  #personalMenuRef
  (languageClicked)="langSwitchRef.open()"
  (settingsClicked)="userSettingsRef.open()"
></app-personal-menu>

<app-lang-switch-dialog #langSwitchRef></app-lang-switch-dialog>

<app-user-settings-dialog #userSettingsRef></app-user-settings-dialog>

<app-pwa-install-guide #pwaInstallRef></app-pwa-install-guide>
